var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox","name":"toggle"}}),_c('label',{attrs:{"for":"toggle"}},[_c('i')]),_c('span')])
}]

export { render, staticRenderFns }